import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

/** Allowed tags for blog / rich text from API (must align with blog/sanitize.py). */
const PURIFY_CONFIG: DOMPurify.Config = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'u', 's', 'a', 'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'code',
    'img', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'hr', 'span',
  ],
  ALLOWED_ATTR: ['href', 'title', 'rel', 'target', 'src', 'alt', 'width', 'height', 'class'],
  ALLOW_DATA_ATTR: false,
};

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html || '', PURIFY_CONFIG);
}

interface SafeHtmlProps {
  html: string;
  className?: string;
}

/**
 * Renders sanitized HTML. This is the only component that may use dangerouslySetInnerHTML.
 */
const SafeHtml: React.FC<SafeHtmlProps> = ({ html, className }) => {
  const clean = useMemo(() => sanitizeHtml(html), [html]);
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
};

export default SafeHtml;
